import { initPostHogClient } from '@/lib/posthog-client'

initPostHogClient()
